import React, { useEffect, useState } from 'react';
import { Link } from "react-router-dom";
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import ReactDOM from 'react-dom';

const Procoorbot = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isStart, setIsStart] = useState(false);
  const [domain, setDomain] = useState('');

  useEffect(() => {
    const domain=  window.location.origin
    setDomain(domain)
  }, []);
  const sleep = (ms) => {
    return new Promise((resolve) => setTimeout(resolve, ms));
  };

  const scrollContainer = () => {
    const inner = document.getElementById('procoorbot-inner');
    inner.scrollTop = inner.scrollHeight;
  };

  const insertNewChatItem = (elem) => {
    const procoorbot = document.getElementById('procoorbot');
    procoorbot.appendChild(elem);
    scrollContainer();
    elem.classList.add('activated');
  };

  const printResponse = async (step) => {
    if (!step || !step.text) {
      return;
    }

    const response = document.createElement('div');
    response.classList.add('massges-response');
    const logoImg = document.createElement('img');
    logoImg.src = 'assets/images/icon_log_chatbot.png';
    logoImg.classList.add('logo-image');
    const logoChat = document.createElement('span');
    logoChat.classList.add('logo_ChatBot');
    logoChat.appendChild(logoImg);
    response.appendChild(logoChat);

    const elementMSG = document.createElement('span');
    elementMSG.innerHTML = `<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="24px" height="30px" viewBox="0 0 24 30" style="enable-background:new 0 0 50 50;" xml:space="preserve">
      <rect x="0" y="0" width="4" height="10" fill="rgb(155, 166, 178)">
        <animateTransform attributeType="xml" attributeName="transform" type="translate" values="0 0; 0 20; 0 0" begin="0" dur="0.6s" repeatCount="indefinite">
        </animateTransform>
      </rect>
      <rect x="10" y="0" width="4" height="10" fill="rgb(155, 166, 178)">
        <animateTransform attributeType="xml" attributeName="transform" type="translate" values="0 0; 0 20; 0 0" begin="0.2s" dur="0.6s" repeatCount="indefinite">
        </animateTransform>
      </rect>
      <rect x="20" y="0" width="4" height="10" fill="rgb(155, 166, 178)">
        <animateTransform attributeType="xml" attributeName="transform" type="translate" values="0 0; 0 20; 0 0" begin="0.4s" dur="0.6s" repeatCount="indefinite">
        </animateTransform>
      </rect>
    </svg>`;

    const stepText = document.createElement('div');
    stepText.classList.add('chat-response');
    const textContent = document.createTextNode(step.text);
    stepText.appendChild(elementMSG);
    response.appendChild(stepText);
    insertNewChatItem(response);

    setTimeout(() => {
      stepText.removeChild(elementMSG);
      stepText.appendChild(textContent);
    }, 600);

    await sleep(1000);

    if (step.options) {
      const choices = document.createElement('div');
      choices.classList.add('choices');
      step.options.forEach(function (option) {
        const button = document.createElement(option.url ? 'a' : 'button');
        button.classList.add('choice');
        button.innerHTML = option.text;
        if (option.url) {
          console.log(option.url)
          button.href = option.url;
          button.target = '_blank'; // Open link in new tab
        } else {
          button.dataset.next = option.next;
        }
        choices.appendChild(button);
      });
      insertNewChatItem(choices);
    } else if (step.optionsCards) {
      const responseContainer = document.createElement('div');
      const sliderElement = (
        <Slider {...settings}>
          {step.optionsCards.map((optionCard, index) => (
            <div key={index} className="item">
              <a target='_blank' href={optionCard.url} className='card_slider'>
                <div className='icon'>
                  <img src={optionCard.img} alt={optionCard.title} />
                </div>
                <div className='text'>
                  <h4 className="card-title">{optionCard.title}</h4>
                  <p className="card-desc">{optionCard.desc}</p>
                  <a className="img_More" target='_blank' href={optionCard.url}>
                    <img
                      src="assets/images/icons/arrow-right-bule16.svg"
                      className="arrow"
                      alt="arrow"
                    />
                  </a>
                </div>

              </a>
            </div>
          ))}
        </Slider>

      );
      const choices = document.createElement('div');
      choices.classList.add('choices');
      step.optionsChoice.forEach(function (option) {
        const button = document.createElement(option.url ? 'a' : 'button');
        button.classList.add('choice');
        button.innerHTML = option.text;
        if (option.url) {
          button.href = option.url;
          button.target = '_blank'; // Open link in new tab
        } else {
          button.dataset.next = option.next;
        }
        choices.appendChild(button);
      });

      ReactDOM.render(sliderElement, responseContainer);
      insertNewChatItem(responseContainer);
      insertNewChatItem(choices);

    } else if (step.next) {
      printResponse(chat[step.next]);
    }
  };

  const printChoice = (choice) => {
    const choiceElem = document.createElement('div');
    choiceElem.classList.add('chat-ask');
    choiceElem.innerHTML = choice.innerHTML;
    insertNewChatItem(choiceElem);
  };

  const disableAllChoices = () => {
    const choices = document.querySelectorAll('.choice');
    choices.forEach(function (choice) {
      choice.disabled = 'disabled';
    });
    return;
  };

  const handleChoice = async (e) => {
    if (!e.target.classList.contains('choice') || 'A' === e.target.tagName) {
      var button = e.target.closest('#procoorbot-container .choice');

      if (button !== null) {
        button.click();
      }

      return;
    }

    e.preventDefault();
    const choice = e.target;

    disableAllChoices();

    printChoice(choice);
    scrollContainer();

    await sleep(1500);

    if (choice.dataset.next) {
      printResponse(chat[choice.dataset.next]);
    }
  };

  const handleRestart = () => {
    startConversation();
  };

  const startConversation = () => {
    printResponse(chat[1]);
    setIsStart(true);
    setIsOpen(true)
  };

  const ClosedBot = () => {
    setIsOpen(false)
  }
  const OpenBot = () => {
    setIsOpen(true)
  }
  const subDomain = `${domain}/accounts`
  const chat = {
    1: {
      text: 'Hello there! 👋  It`s nice to meet you!',
      next: 2,
    },
    2: {
      text:
        'What are you inquiring about?',
      options: [
        {
          text: 'About Procoor',
          next: 3,
        },
        {
          text: 'Our Services',
          next: 4,
        },
        {
          text: 'Contact Sales',
          url:`${subDomain}/contact`,
        },
      ],
    },
    3: {
      text:
        'Procoor is a complete construction management system specially designed by engineering and construction professionals for the construction industry.',
      options: [
        {
          text: 'Software Management',
          next: 5,
        },
        {
          text: 'Planning Department',
          next: 6,
        },
        {
          text: 'Contract Management',
          next: 7,
        },
        {
          text: '👈 Back to menu',
          next: 2,
        },
      ],
    },
    4: {
      text: 'Discover our tailored solutions in Software Management & Planning Department & Contract Management. With Procoor, our integrated construction management system developed by industry experts, we streamline workflows and ensure seamless collaboration throughout your construction project.',
      options: [
        {
          text: 'Software Management',
          next: 5,
        },
        {
          text: 'Planning Department',
          next: 6,
        },
        {
          text: 'Contract Management',
          next: 7,
        },
        {
          text: '👈 Back to menu',
          next: 2,
        },
      ],
    },
    5: {
      text: 'Procoor is a comprehensive software solution developed by engineering and construction experts for the construction industry, that simplifies project management processes.',
      optionsCards: [
        {
          title: 'Project Management',
          desc: 'Procoor software helps manage projects efficiently, providing tools for task creation, progress tracking, and collaboration',
          img: 'assets/images/Services_icon/icon_pm.svg',
          url: '/pm',
        },
        {
          title: 'Facility management',
          desc: 'Procoor Facility Management software optimizes facility operations with integrated asset, work order, and maintenance.',
          img: 'assets/images/Services_icon/icon_fm.svg',
          url: '/fm',
        },
        {
          title: 'Human Resources',
          desc: 'Procoor HR Software streamlines processes, saves time, offers applicant tracking, onboarding, performance management.',
          img: 'assets/images/Services_icon/icon_hr.svg',
          url: '/hr',
        },
        {
          title: 'CRM',
          desc: 'Procoor streamlines customer tracking, stores data, generates reports, manages contracts, tickets, and modifications.',
          img: 'assets/images/Services_icon/icon_crm.svg',
          url: '/crm',
        },
        {
          title: 'Accounting',
          desc: 'Procoor Accounting Software helps manage finances efficiently, streamlining bookkeeping and financial processes.',
          img: 'assets/images/Services_icon/icon_ac.svg',
          url: '/accounting',
        }
      ],
      optionsChoice: [
        {
          text: 'Contact Sales',
          url:`${subDomain}/contact`,
        },
        {
          text: 'Planning Department',
          next: 6,
        },
        {
          text: 'Contract Management',
          next: 7,
        },
        {
          text: '👈 Back to menu',
          next: 2,
        },
      ],
    },
    6: {
      text: "Procoor planning team skillfully guides projects from start to finish, ensuring a smooth journey. Create a comprehensive project baseline to align with specifications and project requirements collaborating with project stakeholders",
      options: [
        {
          text: 'Contact Sales',
          url:`${subDomain}/contact`,
        },
        {
          text: 'Software Management',
          next: 5,
        },
        {
          text: 'Contract Management',
          next: 7,
        },
        {
          text: '👈 Back to menu',
          next: 2,
        },
      ],
    },
    7: {
      text: 'Procoor is offering a sound drafting mechanisms to design contracts to fit the international and local demands, to define all the commercial and legal allocations between the parties. All forms and ad hoc contracts can be offered to highlights and exercise the agreed brief and sophisticated negotiations at the pre-contracting stage',
      options: [
        {
          text: 'Contact Sales',
          url:`${subDomain}/contact`,
        },
        {
          text: 'Software Management',
          next: 5,
        },
        {
          text: 'Planning Department',
          next: 6,
        },
        {
          text: '👈 Back to menu',
          next: 2,
        },
      ],
    },
  };

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1.25,
    slidesToScroll: 1,
  };


  return (
    <>
      <Link className='chat_whatsapp' to={"https://wa.me/phone=19296537771&text="} target="_blank">
        <svg fill="#fff" height="200px" width="200px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 308 308" xmlSpace="preserve"><g id="SVGRepo_bgCarrier" strokeWidth={0} /><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round" /><g id="SVGRepo_iconCarrier"> <g id="XMLID_468_"> <path id="XMLID_469_" d="M227.904,176.981c-0.6-0.288-23.054-11.345-27.044-12.781c-1.629-0.585-3.374-1.156-5.23-1.156 c-3.032,0-5.579,1.511-7.563,4.479c-2.243,3.334-9.033,11.271-11.131,13.642c-0.274,0.313-0.648,0.687-0.872,0.687 c-0.201,0-3.676-1.431-4.728-1.888c-24.087-10.463-42.37-35.624-44.877-39.867c-0.358-0.61-0.373-0.887-0.376-0.887 c0.088-0.323,0.898-1.135,1.316-1.554c1.223-1.21,2.548-2.805,3.83-4.348c0.607-0.731,1.215-1.463,1.812-2.153 c1.86-2.164,2.688-3.844,3.648-5.79l0.503-1.011c2.344-4.657,0.342-8.587-0.305-9.856c-0.531-1.062-10.012-23.944-11.02-26.348 c-2.424-5.801-5.627-8.502-10.078-8.502c-0.413,0,0,0-1.732,0.073c-2.109,0.089-13.594,1.601-18.672,4.802 c-5.385,3.395-14.495,14.217-14.495,33.249c0,17.129,10.87,33.302,15.537,39.453c0.116,0.155,0.329,0.47,0.638,0.922 c17.873,26.102,40.154,45.446,62.741,54.469c21.745,8.686,32.042,9.69,37.896,9.69c0.001,0,0.001,0,0.001,0 c2.46,0,4.429-0.193,6.166-0.364l1.102-0.105c7.512-0.666,24.02-9.22,27.775-19.655c2.958-8.219,3.738-17.199,1.77-20.458 C233.168,179.508,230.845,178.393,227.904,176.981z" /> <path id="XMLID_470_" d="M156.734,0C73.318,0,5.454,67.354,5.454,150.143c0,26.777,7.166,52.988,20.741,75.928L0.212,302.716 c-0.484,1.429-0.124,3.009,0.933,4.085C1.908,307.58,2.943,308,4,308c0.405,0,0.813-0.061,1.211-0.188l79.92-25.396 c21.87,11.685,46.588,17.853,71.604,17.853C240.143,300.27,308,232.923,308,150.143C308,67.354,240.143,0,156.734,0z M156.734,268.994c-23.539,0-46.338-6.797-65.936-19.657c-0.659-0.433-1.424-0.655-2.194-0.655c-0.407,0-0.815,0.062-1.212,0.188 l-40.035,12.726l12.924-38.129c0.418-1.234,0.209-2.595-0.561-3.647c-14.924-20.392-22.813-44.485-22.813-69.677 c0-65.543,53.754-118.867,119.826-118.867c66.064,0,119.812,53.324,119.812,118.867 C276.546,215.678,222.799,268.994,156.734,268.994z" /> </g> </g></svg>
      </Link>
      <div className={"frame-content"}>
        {isOpen === false ?
          <button className='open-chat' onClick={isStart === true ? OpenBot : startConversation}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              version="1.1"
              xmlnsXlink="http://www.w3.org/1999/xlink"
              width={512}
              height={512}
              x={0}
              y={0}
              viewBox="0 0 512 512"
              style={{ enableBackground: "new 0 0 512 512" }}
              xmlSpace="preserve"
              className=""
            >
              <g>
                <path
                  d="M317.5 178h-123c-24.537 0-44.5 19.962-44.5 44.5s19.962 44.5 44.5 44.5h123c24.537 0 44.5-19.962 44.5-44.5S342.037 178 317.5 178zm-104.664 49.999c0 8.284-6.716 15-15 15s-15-6.716-15-15v-11c0-8.284 6.716-15 15-15s15 6.716 15 15zm116.327 0c0 8.284-6.716 15-15 15s-15-6.716-15-15v-11c0-8.284 6.716-15 15-15s15 6.716 15 15z"
                  fill="#fff"
                  opacity={1}
                  data-original="#fff"
                  className=""
                />
                <path
                  d="M437 257.997v-28.994C437 128.728 355.752 50 256 50c-99.859 0-181 78.74-181 179.003v28.994C75 304.264 112.741 342 159.003 342h193.994C399.259 342 437 304.259 437 257.997zm-242.5 39.002c-41.079 0-74.5-33.42-74.5-74.5s33.42-74.5 74.5-74.5h123c41.079 0 74.5 33.42 74.5 74.5s-33.421 74.5-74.5 74.5zM334 402h-33c-16.5 0-30 13.5-30 30s13.5 30 30 30h33c16.5 0 30-13.5 30-30s-13.5-30-30-30zM482 356.497C482 389.835 453.144 418 418.986 418h-26.652A59.896 59.896 0 0 1 394 432c0 5.541-.771 10.902-2.183 16h27.169C469.405 448 512 406.097 512 356.497V327.18c-8.725 6.565-18.922 11.274-30 13.532zM467 161.221h-1.298V74.477c0-8.284-6.716-15-15-15s-15 6.716-15 15v44.348C456.087 151.477 467 189.324 467 229.003v28.994c0 19.615-4.98 38.089-13.742 54.224H467c24.813 0 45-20.187 45-45v-61c0-24.813-20.187-45-45-45zM45 229.003c0-39.697 10.913-77.556 31.297-110.212V74.477c0-8.284-6.716-15-15-15s-15 6.716-15 15v86.744H45c-24.813 0-45 20.187-45 45v61c0 24.813 20.187 45 45 45h13.742C49.98 296.086 45 277.613 45 257.997z"
                  fill="#fff"
                  opacity={1}
                  data-original="#fff"
                  className=""
                />
              </g>
            </svg>
          </button>
          : null
        }
        <div id="procoorbot-container" className={isOpen === false ? "d-none" : ''} onClick={handleChoice}>
          <div className="header_Bot">
            <div className='logo_Bot'>
              <svg
                width={40}
                height={40}
                viewBox="0 0 40 40"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M20 40C31.0457 40 40 31.0457 40 20C40 8.95431 31.0457 0 20 0C8.95431 0 0 8.95431 0 20C0 23.0712 0.692228 25.9806 1.92917 28.5809C2.68194 30.1634 3.63645 31.6313 4.75946 32.9515C5.23999 33.5164 5.75137 34.0543 6.291 34.5625C6.88888 35.1255 7.52144 35.6522 8.18512 36.1389C11.4955 38.5664 15.5803 40 20 40Z"
                  fill="#CCDDFF"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M13.2929 25.3785C13.2933 23.525 13.2863 21.6716 13.2945 19.8186C13.3147 15.0836 18.3963 11.7812 22.7222 13.687C25.6525 14.9782 27.0971 17.4058 26.9383 20.7729C26.817 23.3405 24.8866 25.7854 22.1628 26.6224C21.232 26.9086 20.2098 26.9638 19.2259 26.9893C18.2288 27.0153 18.2025 26.8637 18.2173 24.5881C18.2218 23.857 18.2033 23.184 19.2547 23.2446C20.6203 23.3236 21.8551 23.0156 22.663 21.7803C23.4416 20.5888 23.3886 19.2601 22.5466 18.1303C21.8366 17.1776 20.5113 16.7381 19.3259 17.0623C18.0429 17.4136 17.0956 18.438 17.0689 19.8042C17.0068 22.9945 17.0245 26.1874 17.0792 29.3782C17.0841 29.6723 17.5411 30.1484 17.8586 30.218C21.675 31.0562 25.0516 30.0953 27.7034 27.2554C33.1552 21.4175 30.5083 12.6346 23.4811 10.2635C17.2836 8.17238 11.3033 12.147 10.0647 17.8234C9.72908 19.361 9.7188 20.8763 10.0507 22.4101C10.1692 22.9579 10.4025 23.2899 11.0079 23.24C11.7389 23.1795 11.9639 23.5806 11.9614 24.245C11.9511 27.3604 12.2436 26.9469 9.33667 27.0425C8.17425 27.0808 7.57618 26.7294 7.11631 25.6075C3.8812 17.718 7.91347 8.68311 16.1644 6.56524C24.9302 4.31516 32.2227 8.95041 34.0601 17.4919C35.7852 25.5123 29.6959 33.3981 21.5372 34.1239C19.047 34.3454 16.7065 33.9476 14.4101 33.0456C13.6199 32.7354 13.2382 32.2721 13.2711 31.3495C13.3418 29.3613 13.2925 27.3691 13.2929 25.3785Z"
                  fill="#143BFF"
                />
              </svg>
            </div>
            <div className="InfoBot">
              <p className="TitleBot">ProcoorBot</p>
              <p className="status">Online</p>
            </div>
            <button className='closed_Bot' onClick={ClosedBot}>
              <svg
                width="14px"
                height="14px"
                viewBox="0 0 14 14"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                className="oda-chat-header-button-icon"
                role="img"
                aria-label="Close"
              >
                {" "}

                <g
                  id="Page-1"
                  stroke="none"
                  strokeWidth={1}
                  fill="none"
                  fillRule="evenodd"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  {" "}
                  <g
                    id="Chat-Window"
                    transform="translate(-348.fff, -68.fff)"
                    stroke="#1c1e26"
                    strokeWidth={2}
                  >
                    {" "}
                    <g id="Card" transform="translate(30.fff, 45.fff)">
                      {" "}
                      <g id="Header">
                        {" "}
                        <g id="Close">
                          {" "}
                          <g transform="translate(319.fff, 24.fff)">
                            {" "}
                            <line
                              x1={0}
                              y1="11.7391304"
                              x2="11.7391304"
                              y2={0}
                              id="Path"
                            />{" "}
                            <line
                              x1={0}
                              y1="11.7391304"
                              x2="11.7391304"
                              y2={0}
                              id="Path-Copy"
                              transform="translate(5.869565, 5.869565) scale(1, -1) translate(-5.869565, -5.869565) "
                            />{" "}
                          </g>{" "}
                        </g>{" "}
                      </g>{" "}
                    </g>{" "}
                  </g>{" "}
                </g>{" "}
              </svg>

            </button>
          </div>
          <div id="procoorbot-inner">
            <div id="procoorbot"></div>
          </div>
          <div className='footer_Bot'>
            <p> Powered by <span>Procoor</span></p>
          </div>
        </div>
      </div>
    </>


  );
};

export default Procoorbot;
